import { Service } from '@angular/core';
import { Paragraph } from '@app/models/paragraph.model';

interface ContentLink {
  label: string;
  sectionId: string;
  url?: string;
}

@Service()
export class ContentLinkService {
  getContentLinks(
    paragraphs: ReadonlyArray<Paragraph> | undefined
  ): ContentLink[] | undefined {
    if (!paragraphs) return undefined;

    return paragraphs
      .filter((pg) => pg?.anchorLink)
      .map((pg) => ({
        label: pg.anchorLink!,
        sectionId: pg.id,
        ...(pg.anchorLinkUrl && { url: pg.anchorLinkUrl }),
      }));
  }
}
